export enum ReturnType {
  SUCCESS = "success",
  FAIL = "fail",
}
